import React from 'react';

import Data from 'data';
import Locale from 'data/locale';

import classNames from 'classnames';
import Tooltip from 'ui/tooltip';
import { formatValue, StatTooltip } from 'components/stats/Stats';
import { colored } from 'tooltips/builder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { dpsStatList } from 'components/stats/statList';
import { formatNumber } from 'utils/format';

const _L = Locale('ui-calculator');

const statValue = (stat, src) => colored(formatValue(stat, stat.value(src), src), stat.color(src));

const damageTypes = {
  attack: 'Attack',
  spell: 'Spell',
  offhand: 'Off-Hand',
  missile: 'Missile',
  trail: 'Trail',
  cloud: 'Cloud',
  explosion: 'Explosion',
  bolt: 'Bolt',
  chain: 'Chain',
  nova: 'Nova',
  burn: 'Burn',
  shard: 'Shard',
  crack: 'Crack',
};

function damageType(damage, entry) {
  if (damage === 'damage') {
    return _L(damageTypes[entry.weapon ? 'attack' : 'spell']);
  } else if (damageTypes[damage]) {
    return _L(damageTypes[damage]);
  } else {
    const m = damage.match(/^skill\[(\d+)\]\.(.*)$/);
    const skill = m && Data.skills[m[1]];
    if (!skill) return _L`Unknown`;
    const desc = Data.skillDesc[skill.skilldesc];
    const name = Locale.strings[desc?.strname] || skill.skill;
    return `${name} - ${damageType(m[2], entry)}`;
  }
}

const StatLine = ({ stat, src, name }) => (
  <li>
    <Tooltip tooltip={<StatTooltip stat={stat} stats={src}/>} disabled={!stat.tooltip}>
      <span>{name || stat.name}: {statValue(stat, src)}</span>
    </Tooltip>
  </li>
);

function SkillDPSLine({ dps }) {
  const [expanded, setExpanded] = React.useState(false);

  const stat = dpsStatList.entry;
  let label = stat.name;
  if (dps.sumskill) {
    label = _L`Skill ${dps.sumskill}` + ' - ' + label;
  }
  return (
    <div className={classNames("d2p-skill-damage d2p-expandable", {"d2p-expanded": expanded})}>
      <Tooltip tooltip={<StatTooltip stat={stat} stats={dps.total}/>}>
        <span className="d2p-damage-header" onClick={() => setExpanded(e => !e)}>
          {label}: {statValue(stat, dps.total)} <FontAwesomeIcon icon={expanded ? faCaretUp : faCaretDown}/>
        </span>
      </Tooltip>
      {expanded && (
        <ul>
          {Object.entries(dps.entries).map(([name, entry]) => !!entry.dps && <StatLine key={name} name={damageType(name, entry)} stat={stat} src={entry}/>)}
          {!!dps.crushingblow && <li>{_L`Crushing Blow`}: {_L`up to ${formatNumber(dps.crushingblow, 0, 10000)} damage per second`}</li>}
          <li>{_L`Time to kill`}: {_L`${dps.ttk.toFixed(2)} seconds`}</li>
        </ul>
      )}
    </div>
  );
}

export default function SkillDPS({ dps }) {
  if (Array.isArray(dps)) {
    return dps.map(dps => <SkillDPSLine key={dps.sumskill} dps={dps}/>);
  } else {
    return <SkillDPSLine dps={dps}/>;
  }
}
